// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'
import {Icon} from '../icon/Icon';
import {Tooltip} from '../tooltip/Tooltip';

@Component({
    name: 'ButtonLink',
    components: {
        Icon,
        Tooltip,
    },
    mixins: [
        template,
    ]
})
export class ButtonLink extends Vue {

    public get themeClass() {
        if ((this.icon || this.$slots['icon']) && this.$slots.default) {
            return `${this.$appPrefix}-button-link--${this.theme ? this.theme : 'default'}-with-icon`
        }

        if ((this.icon || this.$slots['icon']) && !this.$slots.default) {
            return `${this.$appPrefix}-button-link--${this.theme ? this.theme : 'default'}-icon`
        }

        return `${this.$appPrefix}-button-link--${this.theme ? this.theme : 'default'}`
    }

    public get buttonSizeClass() {
        return `${this.$appPrefix}-button-link--${this.size}`
    }

    public get iconSizeClass() {
        return `${this.$appPrefix}-button-link--icon-${this.iconSize}`
    }

    public get arrowRightClass() {

        // !!! Special case for only right arrow icon !!!
        return (this.icon == this.$icons.ARROW_RIGHT && this.$slots['default']) ? `${this.$appPrefix}-button-link--arrow-right` : ''
    }

    public get disabledClass() {
        if (!this.disabled){
            return ''
        }

        if ((this.icon || this.$slots['icon']) && this.$slots.default) {
            return `${this.$appPrefix}-button-link--${this.theme ? this.theme : 'default'}-with-icon--disabled`
        }

        if ((this.icon || this.$slots['icon']) && !this.$slots.default) {
            return `${this.$appPrefix}-button-link--${this.theme ? this.theme : 'default'}-icon--disabled`
        }

        return `${this.$appPrefix}-button-link--${this.theme ? this.theme : 'default'}--disabled`
    }

    public get inlineClass() {
        return this.inline ? `${this.$appPrefix}-button--inline` : ''
    }

    @Prop([String, Object])
    public to!: any

    @Prop()
    public href!: string

    @Prop()
    public target?: string

    @Prop({default: 'default'})
    public theme!: string

    @Prop()
    public icon?: string
    public defaultIcon?: any = null

    @Prop()
    public iconFile?: string
    public defaultIconFile?: any = null

    @Prop()
    public iconClass?: string

    @Prop({default: 'md'})
    public iconSize?: string

    @Prop({default: 'md'})
    public size?: string

    @Prop()
    public disabled?: boolean

    @Prop({default: false})
    public inline?: boolean
}